export const NEW_LOGIN_REDUCER = 'loginV2';

// Login Constants
export const LOGIN_V2_REQUEST = 'app/NewLogin/LOGIN_V2_REQUEST';
export const LOGIN_V2_SUCCESS = 'app/NewLogin/LOGIN_V2_SUCCESS';
export const LOGIN_V2_FAILURE = 'app/NewLogin/LOGIN_V2_FAILURE';

// SSO Login Constants
export const SSO_LOGIN_V2_REQUEST = 'app/NewLogin/SSO_LOGIN_V2_REQUEST';

export const CHECK_SSO_DOMAIN_REQUEST = 'app/NewLogin/CHECK_SSO_DOMAIN_REQUEST';
export const CHECK_SSO_DOMAIN_SUCCESS = 'app/NewLogin/CHECK_SSO_DOMAIN_SUCCESS';
export const CHECK_SSO_DOMAIN_FAILURE = 'app/NewLogin/CHECK_SSO_DOMAIN_FAILURE';
export const SHOW_PASSWORD_FIELD = 'app/NewLogin/SHOW_PASSWORD_FIELD';

// OTP Constants
export const OTP_MAX_LENGTH = 6;
export const VALIDATE_OTP_REQUEST = 'app/NewLogin/VALIDATE_OTP_REQUEST';
export const VALIDATE_OTP_SUCCESS = 'app/NewLogin/VALIDATE_OTP_SUCCESS';
export const VALIDATE_OTP_FAILURE = 'app/NewLogin/VALIDATE_OTP_FAILURE';

export const RESEND_OTP_REQUEST = 'app/NewLogin/RESEND_OTP_REQUEST';
export const RESEND_OTP_SUCCESS = 'app/NewLogin/RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAILURE = 'app/NewLogin/RESEND_OTP_FAILURE';

// Forgot Password Constants
export const FORGOT_PASSWORD_REQUEST = 'app/NewLogin/FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'app/NewLogin/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'app/NewLogin/FORGOT_PASSWORD_FAILURE';

// Set Password Constants
export const SET_PASSWORD_REQUEST = 'app/NewLogin/SET_PASSWORD_REQUEST';
export const SET_PASSWORD_SUCCESS = 'app/NewLogin/SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAILURE = 'app/NewLogin/SET_PASSWORD_FAILURE';
export const REDIRECT_COUNTDOWN_SECONDS = 5;

// OTP-session Guard Constants (probe /auth/v2/otp-session on page mount)
export const OTP_SESSION_CHECK_REQUEST = 'app/NewLogin/OTP_SESSION_CHECK_REQUEST';
export const OTP_SESSION_CHECK_SUCCESS = 'app/NewLogin/OTP_SESSION_CHECK_SUCCESS';
export const OTP_SESSION_CHECK_FAILURE = 'app/NewLogin/OTP_SESSION_CHECK_FAILURE';

// v2 Logout Constants
export const LOGOUT_V2_REQUEST = 'app/NewLogin/LOGOUT_V2_REQUEST';
export const LOGOUT_V2_SUCCESS = 'app/NewLogin/LOGOUT_V2_SUCCESS';
export const LOGOUT_V2_FAILURE = 'app/NewLogin/LOGOUT_V2_FAILURE';

// Possible guard states surfaced via reducer
export const OTP_SESSION_GUARD = {
  PENDING: 'pending',
  VALID:   'valid',
  INVALID: 'invalid',
};

// Common Constants
export const CLEAR_ERROR = 'app/NewLogin/CLEAR_ERROR';
export const RESET_PASSWORD_FIELD = 'app/NewLogin/RESET_PASSWORD_FIELD';

export const INVALID_CREDENTIALS_MESSAGE = 'Invalid username or password';